import React from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { useStores } from "../../../contexts/StoreContext";
import CustomSelect from "../../CustomSelect/CustomSelect";
import useIsHydrated from "../../hooks/useIsHydrated";

const StyledSelect = styled(CustomSelect)`
  height: 3rem;
  width: 100%;
`;
const roleSelectStyles = {
  container: (provided) => ({ ...provided, width: "100%" }),
  control: (provided) => ({
    ...provided,
    borderRadius: "none",
    boxShadow: "none",
    height: "3rem",
  }),
  menu: (provided) => ({ ...provided }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
};

function RoleSelect(props) {
  const { placeholder } = props;
  const { rolesStore, filtersStore } = useStores();
  const isHydrated = useIsHydrated();
  const { setFilter, filters } = filtersStore;
  const { roleOptions } = rolesStore;

  const handleRoleSelect = (role) => {
    setFilter("category", role?.label);
  };

  const selectedRole = rolesStore.rolesByRoleName[filters.category];

  const selectedRoleValue = selectedRole
    ? {
        label: selectedRole.roleName,
        value: selectedRole.roleName,
      }
    : null;

  return (
    <StyledSelect
      aria-label="Select role"
      className="border-0 h-100"
      instanceId="categorySelect"
      isClearable
      menuPortalTarget={isHydrated ? document.body : null}
      onChange={handleRoleSelect}
      options={roleOptions}
      placeholder={placeholder || "Select role"}
      styles={roleSelectStyles}
      value={selectedRoleValue}
    />
  );
}

export default observer(RoleSelect);

RoleSelect.defaultProps = {
  placeholder: "",
};

RoleSelect.propTypes = {
  placeholder: PropTypes.string,
};
